export const PYMENT = {
  TRANSFER: 'transferencia',
};

export const FINES_TYPE = {
  NO_FINE: 'Sin multa',
};